export const LUMINARY_CODE = [
101,100,112,64,36,51,35,100,114,105,115,104,116,105
];